<script lang="ts">
  // libs
  import QuantityDealText from "@shared/svelte/Components/Deal/QuantityDealText.svelte";

  // components
  import Icon from "@shared/svelte/Components/Icon.svelte";

  // types
  import type { CartProduct } from "@shared/types/ProductLine";
  import { DISCOUNT_AMOUNT_TYPES } from "@shared/types/Deals";
  import type { OrderProductDiscount } from "@shared/types/Deals";

  // props
  export let product: CartProduct;

  // data
  let quantityWithRequirementsDiscount;
  let applicableDeals: OrderProductDiscount[] = [];
  let quantityDeal;

  // functions
  const getAppliedDiscount = () => {
    applicableDeals = product.discounts.filter(d => !d.just_an_upsell);

    quantityDeal = applicableDeals.find(
      d =>
        d.discount && !d.discount.deal_tier_id && !isQuantityWithRequirementsDiscount(d.discount),
    );

    quantityWithRequirementsDiscount = applicableDeals.find(
      d =>
        d &&
        d.discount &&
        !d.discount.deal_tier_id &&
        isQuantityWithRequirementsDiscount(d.discount),
    );
  };
  const isQuantityWithRequirementsDiscount = discount =>
    discount.amount_type === DISCOUNT_AMOUNT_TYPES.QUANTITY_WITH_REQUIREMENTS;

  // reactives
  $: if (product?.discounts) getAppliedDiscount();
</script>

{#if quantityWithRequirementsDiscount}
  <div class="fizz-tooltip-container">
    <div
      class="fizz-tooltip-trigger fizz-flex-row"
      id="special-deals-tooltip"
      aria-describedby="special-deals-tooltip"
    >
      <span class="fizz-inline-4">
        <Icon
          type={"Deal"}
          extraClassNames={"fizz-icon-8"}
          extraStyles={"padding: 1px;"}
          color={"#595959"}
        />
      </span>
      <span
        class="fizz-text-subdued fizz-underline-dashed fizz-text-small"
        data-testid={`special-deals-tooltip-${quantityWithRequirementsDiscount.discount.id}`}
      >
        <QuantityDealText
          cartProduct={product}
          discount={quantityWithRequirementsDiscount.discount}
          discount_id={quantityWithRequirementsDiscount.discount.id}
          showAdditionalRequirements={true}
        />
      </span>
    </div>
    <div
      class="fizz-tooltip fizz-tooltip-top fizz-tooltip-center"
      role="tooltip"
      id="special-deals-tooltip-desc"
      style="--max-width: 300px;"
      data-testid={`special-deals-tooltip-desc-${quantityWithRequirementsDiscount.discount.id}`}
    >
      Special discounts: These discounts are not guaranteed. They will apply at the discretion of
      your sales rep on your final invoice and will not apply to your cart total.
    </div>
  </div>
{/if}
